export enum Status {
    CONCEPT = 'status_concept',
    SENT = 'status_sent',
    RESENT = 'status_resent',
    PAID = 'status_paid',
    CHANGED = 'status_changed'
}
